<template>
    <div>
        <button>{{test}}</button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            test: '초기값'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/demo_page/test.vue